import React, { Component } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./Footer.css";
import { Link } from "react-router-dom";
import footerImage from "../../assets/Images/vk-group-10-x.png";
import paymentInfo from "../../assets/Images/group@2x.png";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";

class Footer extends Component {
  state = {
    footerData: [
      // {
      //   name: "Products",
      //   key: 0,
      //   list : [
      //     {
      //       name : 'Catalogue',
      //       path : '/catalogue'
      //     },
      //     {
      //       name : 'Xamidea',
      //     },
      //     {
      //       name : 'Children books - Future Kids series',
      //       path : '/futurekids'
      //     },

      //   ]
      // },
      {
        name: "Resources",
        key: 1,
        list: [
          {
            name: "Archives",
            path: "/resources",
          },
          {
            name: "Order Form",
            path: "/orderform",
          },
          {
            name: "Request Free Sample Copy",
            path: "/samplecopy",
          },
          {
            name: "Publish With Us",
            path: "/publishwithus",
          },
        ],
      },
      {
        name: "About VK Global",
        key: 2,
        list: [
          {
            name: "Company",
            path: "/about",
          },
          {
            name: "Contact Us",
            path: "/contact",
          },
          {
            name: "Privacy Policy",
            path: "/privacy",
          },
          {
            name: "FAQ",
            path: "/faq",
          },
        ],
      },
    ],
  };
  render() {
    return (
      <div>
        <div className="footer">
          <Container>
            <Row className="footerRow">
              <Col sm={3}>
                <div className="footerLogo">
                  <img src={footerImage} alt = "footer"/>
                </div>
              </Col>
              <Accordion className="mobileFooter">
                <Card className="mobileAccordion">
                  <Accordion.Toggle
                    className="accordion"
                    as={Card.Header}
                    eventKey="10"
                  >
                    Products
                    <p className="float-right icon dripicons-plus"></p>
                  </Accordion.Toggle>

                  <Accordion.Collapse eventKey="10">
                    <Card.Body>
                      <ul className = "manualLink">
                        <Link to="/catalogue">
                          <li>Catalogue</li>
                        </Link>
                        <br />
                        <li>
                          <a
                            style={{ color: " #4a4a4a" }}
                            href="https://xamidea.in/"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Xamidea
                          </a>
                        </li>
                        <br />

                        <li>
                          <a
                            style={{ color: "#4a4a4a" }}
                            href="http://www.futurekids.in/"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Children books - Future Kids series
                          </a>
                        </li>
                      </ul>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
                {this.state.footerData.map((smFooter, index) => {
                  return (
                    <Card className="mobileAccordion" key={index + 1}>
                      <Accordion.Toggle
                        className="accordion"
                        as={Card.Header}
                        eventKey={smFooter.key}
                      >
                        {smFooter.name}
                        <p className="float-right icon dripicons-plus"></p>
                      </Accordion.Toggle>
                      {smFooter.list.map((smFooterDetail, index) => {
                        return (
                          <Accordion.Collapse
                            key={index}
                            eventKey={smFooter.key}
                          >
                            <Card.Body>
                              <ul>
                                <Link to={smFooterDetail.path}>
                                  <li>{smFooterDetail.name}</li>
                                </Link>
                              </ul>
                            </Card.Body>
                          </Accordion.Collapse>
                        );
                      })}
                    </Card>
                  );
                })}
              </Accordion>
              <Col sm={9}>
                <div className="listing">
                  <div className="col">
                    <h1>Products</h1>
                    <ul className = "manualLink">
                      <Link to="/catalogue">
                        <li>Catalogue</li>
                      </Link>
                      <li>
                        <a
                          style={{ color: " #4a4a4a" }}
                          href="https://xamidea.in/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Xamidea
                        </a>
                      </li>
                      <li>
                        <a
                          style={{ color: "#4a4a4a" }}
                          href="http://www.futurekids.in/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Children books - Future Kids series
                        </a>
                      </li>
                    </ul>
                  </div>
                  {this.state.footerData.map((footer, index) => {
                    return (
                      <div className="col" key={index + 1}>
                        <h1>{footer.name}</h1>
                        {footer.list.map((footerDetail, index) => {
                          return (
                            <ul key={index}>
                              <Link to={footerDetail.path}>
                                <li> {footerDetail.name}</li>
                              </Link>
                            </ul>
                          );
                        })}
                      </div>
                    );
                  })}
                </div>
              </Col>
            </Row>
            <Row>
              <Col sm={3}></Col>
              <Col sm={9}>
                <div className="transaction">
                  <p>We Accept</p>
                  <img src={paymentInfo} alt = "payment" />
                </div>
              </Col>
            </Row>
            <div className="copyRight">
              © VK Global Publications Pvt Ltd, 2020. All rights reserved.
            </div>
          </Container>
        </div>
      </div>
    );
  }
}

export default Footer;
